import React from 'react';
import { motion } from 'framer-motion';
import { SectionWrapper, childVariants } from './SectionWrapper';
import { CheckIcon, XIcon } from 'lucide-react';
export function WhoForSection() {
  return <SectionWrapper alternate data-id="element-318">
      <motion.h2 className="font-heading text-2xl md:text-3xl font-bold text-cream mb-12" variants={childVariants} data-id="element-319">
        Who this is for
      </motion.h2>

      {/* For You */}
      <motion.div className="mb-12" variants={childVariants} data-id="element-320">
        <p className="font-heading text-lg text-teal-light mb-6" data-id="element-321">
          This is for you if:
        </p>
        <ul className="space-y-4" data-id="element-322">
          <li className="flex items-start gap-3 font-body text-lg text-cream leading-relaxed-plus" data-id="element-323">
            <CheckIcon className="w-5 h-5 text-teal mt-1 flex-shrink-0" data-id="element-324" />
            You're a woman 45+
          </li>
          <li className="flex items-start gap-3 font-body text-lg text-cream leading-relaxed-plus" data-id="element-325">
            <CheckIcon className="w-5 h-5 text-teal mt-1 flex-shrink-0" data-id="element-326" />
            You fall asleep but wake up between 2–4am
          </li>
          <li className="flex items-start gap-3 font-body text-lg text-cream leading-relaxed-plus" data-id="element-327">
            <CheckIcon className="w-5 h-5 text-teal mt-1 flex-shrink-0" data-id="element-328" />
            You feel wired, anxious, hot, or mentally "on"
          </li>
          <li className="flex items-start gap-3 font-body text-lg text-cream leading-relaxed-plus" data-id="element-329">
            <CheckIcon className="w-5 h-5 text-teal mt-1 flex-shrink-0" data-id="element-330" />
            <span data-id="element-331">
              You're tired of tips and want a{' '}
              <em className="text-amber" data-id="element-332">protocol</em>
            </span>
          </li>
        </ul>
      </motion.div>

      {/* Not For You */}
      <motion.div variants={childVariants} data-id="element-333">
        <p className="font-heading text-lg text-cream-muted mb-6" data-id="element-334">
          This is not for you if:
        </p>
        <ul className="space-y-4" data-id="element-335">
          <li className="flex items-start gap-3 font-body text-lg text-cream-muted leading-relaxed-plus" data-id="element-336">
            <XIcon className="w-5 h-5 text-cream-faint mt-1 flex-shrink-0" data-id="element-337" />
            You want a guaranteed cure
          </li>
          <li className="flex items-start gap-3 font-body text-lg text-cream-muted leading-relaxed-plus" data-id="element-338">
            <XIcon className="w-5 h-5 text-cream-faint mt-1 flex-shrink-0" data-id="element-339" />
            You need medical diagnosis/treatment advice
          </li>
          <li className="flex items-start gap-3 font-body text-lg text-cream-muted leading-relaxed-plus" data-id="element-340">
            <XIcon className="w-5 h-5 text-cream-faint mt-1 flex-shrink-0" data-id="element-341" />
            You suspect sleep apnea and haven't been evaluated
          </li>
        </ul>
      </motion.div>
    </SectionWrapper>;
}